import Application from "../../Application";
import ApplicantFormDetailsPresenter, {
  IApplicantFormDetailsPresenter
} from "../../presenter/applicants/ApplicantFormDetailsPresenter";
import { IApplicantFormService } from "../../service/form/ApplicantFormService";

export default class ShowApplicantFormDetailsInteractor {
  private application: Application;
  private output?: IApplicantFormDetailsPresenter;
  private applicantFormService: IApplicantFormService;

  constructor(application, applicantFormService) {
    this.application = application;
    this.applicantFormService = applicantFormService;
  }

  execute(formVersionId: number) {
    this.output = ApplicantFormDetailsPresenter({
      application: this.application,
      initialState: {
        formSectionList: [],
        formId: NaN
      }
    });

    this.applicantFormService
      .getApplicantFormDetails(formVersionId)
      .then(this.output && this.output.loadFormSectionList);

    return this.output;
  }
}
